import { render, staticRenderFns } from "./FrequentlyBought.vue?vue&type=template&id=2c104002&"
import script from "./FrequentlyBought.vue?vue&type=script&lang=js&"
export * from "./FrequentlyBought.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports